import {
    Box,
    Flex,
} from "@chakra-ui/react";

import {
    useEffect,
    useState
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import CommissionStats from "./components/CommissionStats";
import CommissionTable from "./components/CommissionTable";
import CommissionHistorySkeleton from "./components/CommissionHistorySkeleton";

import {
    fetchPartnerPayoutsAction,
    fetchReferredDriversAction,
    fetchPendingCommissionsAction,
} from "../../state/actions/driverPartnerActions";
import { exportCommissionReport } from "../../reports_statements/commissionStatementReport";

const CommissionHistory = () => {
    const dispatch =
        useDispatch();

    const {
        driverPartner,
        partnerPayouts,
        referralMilestones,
        pendingCommissions,
    } = useSelector(
        state =>
            state.driverPartner
    );

    const [showSkeleton, setShowSkeleton] =
    useState(true);

useEffect(() => {
    const timer = setTimeout(() => {
        setShowSkeleton(false);
    }, 3000);

    return () => clearTimeout(timer);
}, []);

useEffect(() => {
    dispatch(
        fetchReferredDriversAction(
            1,
            100
        )
    );

    if (
        driverPartner?.driver_partner_id
    ) {
        dispatch(
            fetchPartnerPayoutsAction(
                driverPartner.driver_partner_id,
                1,
                10
            )
        );
        dispatch(
            fetchPendingCommissionsAction(
                1,
                100
            )
        );
    }
}, [
    dispatch,
    driverPartner?.driver_partner_id,
]);
const handleExportStatement =
    () => {
        exportCommissionReport(
            driverPartner,
            partnerPayouts
        );
    };
    const pendingMilestonePayments =
    referralMilestones
        .filter(
            milestone =>
                milestone.commission_status ===
                "Pending"
        )
        .map(
            milestone => ({
                id:
                    milestone.milestone_id,
                payment_reference:
                    `PENDING-${milestone.milestone_id.slice(
                        0,
                        8
                    )}`,
                payment_method:
                    "Pending Commission",
                payout_period:
                    milestone.milestone_type,
                amount:
                    milestone.commission_amount,
                paid_at:
                    null,
                status:
                    "Pending",
                isPending:
                    true,
            })
        );

        const pendingDeliveryCommissions =
    pendingCommissions
        .filter(
            commission =>
                commission.record_type ===
                "COMMISSION"
        )
        .map(
            commission => ({
                id:
                    commission.commission_id,
                payment_reference:
                    `PENDING-${commission.commission_id.slice(
                        0,
                        8
                    )}`,
                payment_method:
                    "Delivery Commission",
                payout_period:
                    "Delivery Commission",
                amount:
                    commission.commission_amount,
                paid_at:
                    null,
                status:
                    commission.commission_status,
                isPending:
                    true,
            })
        );

        const commissionData = [
    ...partnerPayouts,
    ...pendingMilestonePayments,
    ...pendingDeliveryCommissions,
];

if (showSkeleton) {
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <CommissionHistorySkeleton />
                </Box>
            </Flex>
        </Flex>
    );
}
    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
              marginBottom={{
        base: 20,
        md: 0,
    }}
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                    title="Commission History"
                    subtitle="Track all payouts and referral commission earnings."
                    primaryLabel="Export Statement"
                    primaryDisabled={
                        partnerPayouts.length < 5
                    }
                    primaryDisabledTitle="No statement available"
                    primaryDisabledMessage="You need at least 5 payout transactions before exporting a commission statement."
                    onPrimaryClick={handleExportStatement}
                />

                   <CommissionStats
                        payouts={
                            commissionData
                        }
                    />

                   <CommissionTable
                        payouts={
                            commissionData
                        }
                    />
                </Box>
            </Flex>
        </Flex>
    );
};

export default CommissionHistory;